module.exports = __webpack_public_path__ + "static/catalog_hero_dsktp-20cfccc53c369308775fd66f9cf36e49.png";